import * as api from "../api/userAPI";
import * as types from "../constants/userConstants";
import { getPostsAction, getSavedPostsAction } from "./postActions";
export * from "./profileViewRequestActions";
export * from "./followRequestActions";

export const getUserAction = (id) => async (dispatch) => {
  try {
    const { error, data } = await api.getUser(id);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_USER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.GET_USER_FAIL,
      payload: error.message,
    });
  }
};

export const updateUserAction = (id, formData) => async (dispatch) => {
  try {
    const { error, data } = await api.updateUser(id, formData);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_USER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.GET_USER_FAIL,
      payload: error.message,
    });
  }
};

export const getPublicUsersAction = () => async (dispatch) => {
  try {
    const { error, data } = await api.getPublicUsers();

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_PUBLIC_USERS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.GET_PUBLIC_USERS_FAIL,
      payload: error.message,
    });
  }
};

export const getPublicUsersWithMatchingSkillsAction = () => async (dispatch) => {
  try {
    const { error, data } = await api.getPublicUsersWithMatchingSkills();

    if (error) {
      throw new Error(error);
    }

    // Transform the response to match the expected format with matchedSkills
    const transformedData = (data || []).map(user => ({
      _id: user._id,
      name: user.name,
      avatar: user.avatar,
      location: user.location,
      followerCount: user.followerCount,
      matchedSkills: user.mutualSkills || []
    }));

    dispatch({
      type: types.GET_PUBLIC_USERS_SUCCESS,
      payload: transformedData,
    });
  } catch (error) {
    dispatch({
      type: types.GET_PUBLIC_USERS_FAIL,
      payload: error.message,
    });
  }
};

export const getPublicUserAction = (id) => async (dispatch) => {
  try {
    const { error, data } = await api.getPublicUser(id);
    if (error) {
      throw new Error(error);
    }
    
    // Validate data before dispatching
    if (!data || !data._id) {
      throw new Error('Invalid profile data received from API');
    }
    
    dispatch({
      type: types.GET_PUBLIC_USER_PROFILE_SUCCESS,
      payload: data,
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.GET_PUBLIC_USER_PROFILE_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

export const clearPublicUserProfileAction = () => (dispatch) => {
  dispatch({
    type: types.CLEAR_PUBLIC_USER_PROFILE,
  });
};

export const followUserAction = (id) => async (dispatch) => {
  try {
    const { error } = await api.followUser(id);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.CHANGE_FOLLOW_STATUS_SUCCESS,
      payload: { isFollowing: true },
    });
  } catch (error) {
    dispatch({
      type: types.CHANGE_FOLLOW_STATUS_FAIL,
      payload: error.message,
    });
  }
};

export const unfollowUserAction = (id) => async (dispatch) => {
  try {
    const { error } = await api.unfollowUser(id);
    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.CHANGE_FOLLOW_STATUS_SUCCESS,
      payload: { isFollowing: false },
    });
    
    return { success: true };
  } catch (error) {
    dispatch({
      type: types.CHANGE_FOLLOW_STATUS_FAIL,
      payload: error.message,
    });
    
    return { success: false, error: error.message };
  }
};
export const getFollowingUsersAction = (limit = 25, skip = 0) => async (dispatch) => {
  try {
    const { error, data } = await api.getFollowingUsers(limit, skip);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.GET_FOLLOWING_USERS_SUCCESS,
      payload: {
        page: skip / limit + 1,
        users: data.users || data,
        totalUsers: data.totalUsers || data.length,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_FOLLOWING_USERS_FAIL,
      payload: error.message,
    });
  }
};

export const searchFollowingUsersAction = (query) => async (dispatch) => {
  try {
    dispatch({
      type: types.SEARCH_FOLLOWING_USERS_REQUEST,
    });
    
    const { error, data } = await api.searchFollowingUsers(query);
    if (error) {
      throw new Error(error);
    }
    
    dispatch({
      type: types.SEARCH_FOLLOWING_USERS_SUCCESS,
      payload: {
        users: data.users || data,
        totalUsers: data.totalUsers || data.length,
        searchQuery: data.searchQuery || query,
      },
    });
  } catch (error) {
    dispatch({
      type: types.SEARCH_FOLLOWING_USERS_FAIL,
      payload: error.message,
    });
  }
};

export const clearFollowingUsersAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_FOLLOWING_USERS,
  });
};

export const getFollowersUsersAction = (limit = 25, skip = 0) => async (dispatch) => {
  try {
    const { error, data } = await api.getFollowersUsers(limit, skip);
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.GET_FOLLOWERS_USERS_SUCCESS,
      payload: {
        page: skip / limit + 1,
        users: data.users || data,
        totalUsers: data.totalUsers || data.length,
      },
    });
  } catch (error) {
    dispatch({
      type: types.GET_FOLLOWERS_USERS_FAIL,
      payload: error.message,
    });
  }
};

export const searchFollowersUsersAction = (query) => async (dispatch) => {
  try {
    dispatch({
      type: types.SEARCH_FOLLOWERS_USERS_REQUEST,
    });
    
    const { error, data } = await api.searchFollowersUsers(query);
    if (error) {
      throw new Error(error);
    }
    
    dispatch({
      type: types.SEARCH_FOLLOWERS_USERS_SUCCESS,
      payload: {
        users: data.users || data,
        totalUsers: data.totalUsers || data.length,
        searchQuery: data.searchQuery || query,
      },
    });
  } catch (error) {
    dispatch({
      type: types.SEARCH_FOLLOWERS_USERS_FAIL,
      payload: error.message,
    });
  }
};

export const clearFollowersUsersAction = () => async (dispatch) => {
  dispatch({
    type: types.CLEAR_FOLLOWERS_USERS,
  });
};

export const removeFollowerAction = (userId) => async (dispatch) => {
  try {
    const { error, data } = await api.removeFollower(userId);
    if (error) {
      throw new Error(error);
    }
    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.message };
  }
};


export const followUserAndFetchData =
  (toFollowId, currentUser) => async (dispatch) => {
    try {
      await dispatch(followUserAction(toFollowId));
      await dispatch(getPublicUsersAction());
      if (currentUser) {
        await dispatch(getPostsAction());
        await dispatch(getUserAction(currentUser._id));
        await dispatch(getSavedPostsAction());
      }
    } catch (error) {
      dispatch({
        type: types.CHANGE_FOLLOW_STATUS_FAIL,
        payload: "Failed to follow user",
      });
    }
  };

export const getMutualSkillsAction = (userId) => async (dispatch) => {
  try {
    dispatch({ type: types.GET_MUTUAL_SKILLS_REQUEST });
    
    const { error, data } = await api.getMutualSkills(userId);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_MUTUAL_SKILLS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.GET_MUTUAL_SKILLS_FAIL,
      payload: error.message,
    });
  }
};

export const getMutualCommunitiesAction = (userId) => async (dispatch) => {
  try {
    dispatch({ type: types.GET_MUTUAL_COMMUNITIES_REQUEST });
    
    const { error, data } = await api.getMutualCommunities(userId);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_MUTUAL_COMMUNITIES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.GET_MUTUAL_COMMUNITIES_FAIL,
      payload: error.message,
    });
  }
};

export const getPrivacySettingsAction = () => async (dispatch) => {
  try {
    const { error, data } = await api.getPrivacySettings();

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_PRIVACY_SETTINGS_SUCCESS,
      payload: data.privacySettings,
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.GET_PRIVACY_SETTINGS_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

export const updatePrivacySettingsAction = (settings) => async (dispatch) => {
  try {
    const { error, data } = await api.updatePrivacySettings(settings);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.UPDATE_PRIVACY_SETTINGS_SUCCESS,
      payload: data?.privacySettings || data,
    });
    return { success: true, data };
  } catch (error) {
    console.error("updatePrivacySettingsAction error:", error);
    dispatch({
      type: types.UPDATE_PRIVACY_SETTINGS_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

export const blockUserAction = (userId) => async (dispatch) => {
  try {
    const { error, data } = await api.blockUser(userId);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.BLOCK_USER_SUCCESS,
      payload: { userId, data },
    });
    
    // Refresh posts to remove blocked user's posts
    dispatch(getPostsAction(10, 0));
    dispatch(getSavedPostsAction(10, 0));
    
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.BLOCK_USER_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

export const unblockUserAction = (userId) => async (dispatch) => {
  try {
    const { error, data } = await api.unblockUser(userId);

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.UNBLOCK_USER_SUCCESS,
      payload: { userId, data },
    });
    
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.UNBLOCK_USER_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};

export const getBlockedUsersAction = () => async (dispatch) => {
  try {
    const { error, data } = await api.getBlockedUsers();

    if (error) {
      throw new Error(error);
    }

    dispatch({
      type: types.GET_BLOCKED_USERS_SUCCESS,
      payload: data.blockedUsers || [],
    });
    return { success: true, data };
  } catch (error) {
    dispatch({
      type: types.GET_BLOCKED_USERS_FAIL,
      payload: error.message,
    });
    return { success: false, error: error.message };
  }
};